import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { Wordmark } from "./Logo";
import { useLang } from "../i18n";
import { scrollToId } from "../hooks/useSmoothScroll";

export default function Header() {
  const { lang, setLang, t } = useLang();
  const navigate = useNavigate();
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => scrollToId(id), 300);
    } else {
      scrollToId(id);
    }
  };

  const navItems = [
    { id: "how", label: t.nav.how },
    { id: "services", label: t.nav.services },
    { id: "about", label: t.nav.about },
  ];

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-crema/80 backdrop-blur-xl border-b border-charcoal/10" : "bg-transparent"
      }`}
      data-testid="site-header"
    >
      <div className="mx-auto max-w-7xl px-5 md:px-10 h-16 md:h-20 flex items-center justify-between">
        <button
          onClick={() => go("hero")}
          className="transition-transform hover:scale-[1.02] active:scale-95"
          data-testid="header-logo"
          aria-label="He Meant To home"
        >
          <Wordmark iconSize={26} />
        </button>

        <nav className="hidden md:flex items-center gap-9">
          {navItems.map((item) => (
            <button
              key={item.id}
              onClick={() => go(item.id)}
              className="text-sm font-medium text-charcoal/70 hover:text-charcoal transition-colors"
              data-testid={`nav-${item.id}`}
            >
              {item.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-4">
          <div className="flex items-center text-sm font-semibold" data-testid="lang-toggle">
            <button
              onClick={() => setLang("en")}
              className={lang === "en" ? "text-charcoal" : "text-warmgray hover:text-charcoal transition-colors"}
              data-testid="lang-en"
            >
              EN
            </button>
            <span className="mx-1.5 text-warmgray/50">|</span>
            <button
              onClick={() => setLang("es")}
              className={lang === "es" ? "text-charcoal" : "text-warmgray hover:text-charcoal transition-colors"}
              data-testid="lang-es"
            >
              ES
            </button>
          </div>
          <button
            onClick={() => navigate("/book")}
            className="rounded-full bg-charcoal text-crema text-sm font-semibold px-5 py-2.5 hover:bg-coral transition-colors duration-300"
            data-testid="header-book-btn"
          >
            {t.nav.book}
          </button>
        </div>
      </div>
    </motion.header>
  );
}
